import BasicResource from '@/api/resource';

class OnboardingResource extends BasicResource {

    constructor () {
        super('onboarding');
    }

    dict (params) {
        return this.client.request ({
            method: 'get',
            path: '/upyield/v1/dict/onboarding-partners',
            params: { ...params, limit: -1 },
        });
    }

    approve (data) {
        return this.client.request({
            method: 'post',
            path: `/upyield/v1/onboarding/${data.id}/approve`,
            data: data,
        });
    }

    resendVerification (id) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/onboarding/${id}/resend-verification`,
        });
    }

    reject (id) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/onboarding/${id}/reject`,
        });
    }
}

export default new OnboardingResource;
